import React, { Component } from 'react';


import axios from 'axios';

export default class InvalidLicComp extends Component {


    constructor(props) {
        super(props);
       
        this.state = {          
            errorMsgText: "",
            disableButtons: false
        }
       
    }

    render() {
        let renewOption = "";
		if(this.props.ErrMsg && this.props.ErrMsg.startsWith("Invalid"))
			renewOption = <><input id='btnReg' type='button' className="form1-bu" style={{width: "auto",marginRight:"5px",marginTop:"5px"}} value='Renew'
							onClick={(e) => this.registerThisApp(e)} />
						<input id='btnGetStatus' type='button' className="form1-bu" style={{width: "auto",marginRight:"5px",marginTop:"5px"}} value='Check Status'
						onClick={() => this.getReqStatus()} /> </>
        return (
            <div className="terms">
                <div id='TOUContent' style={{ borderWidth: '0px', borderStyle: 'solid', borderRadius: "5px", width: '590px', height: '500px', borderColor: "grey", backgoundColor: "transparent", padding: "5px 10px 0px 0px" }}>
					<div className='wh100' id='touText' style={{ verticalAlign: 'top', borderColor: "grey", borderWidth: "0px" }}>
						<span> { this.props.ErrMsg || "" }</span><br/>
						{renewOption}					 
						<br /><span id='lblErrMsg' dangerouslySetInnerHTML={{ __html: this.state.errorMsgText }}></span>
					</div>
				</div>
            </div>);

    }
    getReqStatus() {

        let webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/GetReqStatus';
        axios({
            url: webMethodUrl,
            method: "POST",
            data: JSON.stringify({}),
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
		.then(resp => {
			let data = (resp.data.d || "");
			this.setState({ errorMsgText: data});
			if (data == "New Licence") window.setTimeout("window.location.reload()", 500);
		})
		.catch(error => {
			this.setState({ disableButtons: false });
			alert('error:' + error);
		})

    }
    registerThisApp(e) {

        let mode = (e.target.value.toLowerCase() == 'renew') ? 'renew' : 'reg';
        let webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/RegisterApp';

        axios({
            url: webMethodUrl,
            method: "POST",
            data: JSON.stringify({ mode: mode }),
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
		.then(resp => {
			let data = resp.data;
			this.setState({ errorMsgText: data.d });
		})
		.catch(error => {
			this.setState({ disableButtons: false });
			alert('error:' + error);
		})
    }
}
